module.exports = __webpack_public_path__ + "img/hr-boiler-N-light.62e3b858.png";